import { transactionsSelectors } from 'app-components/flux/transactions';
import type { TransactionItem } from 'app-components/flux/transactions/transactionsTypes';
import StdDialog from 'components/Dialogs/StdDialog';
import StdDialogActions from 'components/Dialogs/StdDialogActions';
import StdDialogContent from 'components/Dialogs/StdDialogContent';
import { useAppSelector } from 'hooks/redux';
import React from 'react';
import TransactionItemSelect from './TransactionItemSelect';

type TransactionItemSelectDialogProps = {
  open: boolean;
  title?: string;
  onClose?: () => void;
  onConfirm?: (selectedIds: TransactionItem[]) => void;
  txnItemIds: string[];
  disableMultipleRowSelection?: boolean;
  showAccountFilter?: boolean;
  primaryButtonText?: string;
  secondaryAction?: any;
  secondaryNode?: any;
  tertiaryAction?: any;
  tertiaryNode?: any;
  toolbar?: any;
  subtitle?: string;
};

const convertIdsToTransactionItem = (
  selectedIds: string[],
  transactionItems: Immutable.Map<string, TransactionItem>,
) => {
  return selectedIds.reduce<TransactionItem[]>((acc, id) => {
    const item = transactionItems?.get(id ?? '');
    if (item) {
      acc.push(item);
    }
    return acc;
  }, []);
};

export default function TransactionItemSelectDialog(props: TransactionItemSelectDialogProps) {
  const {
    open,
    title,
    onClose,
    onConfirm,
    txnItemIds,
    disableMultipleRowSelection,
    showAccountFilter,
    primaryButtonText,
    secondaryAction,
    secondaryNode,
    toolbar,
    tertiaryAction,
    tertiaryNode,
    subtitle,
  } = props;

  const [selectedIds, setSelectedIds] = React.useState<string[]>([]);
  const transactionItems = useAppSelector(transactionsSelectors.getTransactionItemsById);

  return (
    <StdDialog
      open={open}
      onClose={onClose}
      onConfirm={() => {
        onConfirm?.(convertIdsToTransactionItem(selectedIds, transactionItems));
        // onClose?.();
      }}
      title={title ?? 'Link Transaction'}
      maxWidth='md'
    >
      <StdDialogContent sx={{ pb: 0 }}>
        <TransactionItemSelect
          selectedIds={selectedIds}
          setSelectedIds={setSelectedIds}
          disableMultipleRowSelection={disableMultipleRowSelection}
          txnItemIds={txnItemIds}
          checkboxSelection
          showAccountFilter={showAccountFilter}
          toolbar={toolbar}
          subtitle={subtitle}
        />
      </StdDialogContent>
      <StdDialogActions
        primary={{
          children: primaryButtonText ?? 'Link',
          onClick: () => {
            onConfirm?.(convertIdsToTransactionItem(selectedIds, transactionItems));
            // onClose?.();
          },
          disabled: selectedIds.length === 0,
        }}
        secondary={secondaryAction}
        secondaryNode={secondaryNode}
        tertiaryAction={tertiaryAction}
        tertiaryNode={tertiaryNode}
      />
    </StdDialog>
  );
}
